

// zentrale Rolle-zu-ID-Zuordnung
const roleMap = {

    ADMIN: 1,
    OK: 2,
    SUPERHELFER: 3,
    HELFER: 4,
    GRUENDERVATER: 10,
    PRAESI: 11,
    SUPERPARTNER: 55,
    PARTNER: 56,
    GAST_OK: 80,
    GAST_ANWOHNER: 81,
    GAST_BAND: 82,
    GAST_PETZI: 83,
    GAST_FESTIVAL: 84,
    TECHNIKER: 85,
    PRESSE: 86

};

export default roleMap;
